import { LoadingOverlay } from '@nexans/react-ui-kit'

function RouteLoader() {
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <LoadingOverlay visible />
    </div>
  )
}

export default RouteLoader
